<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("shipping_return") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">

					<base-button size="md" type="neutral" v-if="params.id != 0" @click="showSaveModal = true">{{
						$t("save")
					}}</base-button>
                </div>
            </div>
        </base-header>

        <div class="row">
            <div class="container-fluid mt--6 col-lg-4">
                <div>

					
                    <card
                        header-classes="bg-transparent"
                        footer-classes="bg-transparent"
                        body-classes="px-lg-4 py-lg-4"
                        class=" border-0  mb-4"
                    >

					<div class="row">
						<div class="col-md-6">
							<base-input :label="$t('platform')">
								<el-select
									v-model="platform_id"
									:label="$t('platform')"
									:disabled="lock"
								>
									<el-option
										v-for="option in PlatformTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>
                        <div class="row">
                            <div class="col-md-12">
                                <base-input
                                    :placeholder="$t('scanbarcode')"
                                    v-model="barcode"
									:label="$t('Barcode')"
                                    class="form-control-alternative"
                                    prepend-icon="ni ni-zoom-split-in"
                                    v-on:keyup.enter="handleBarcode"
                                ></base-input>
                            </div>
                        </div>
						<hr/>
						<div class="row">
							<div class="col-md-12">
								<!-- router to /backoffice/packings/shipping/return -->
								<router-link
									:to="{ name: 'ReportOrderReturn' }"
									class="btn btn-primary"
								>
									{{ $t("report_order_return") }}
								</router-link>
							</div>
						</div>
                    </card>
                </div>
            </div>

            <div class="container-fluid mt--6 col-lg-8">
                <div>
                    <!-- card right -->
                    <card
                        class="no-border-card"
                        body-classes="px-0 pb-1"
                        footer-classes="pb-2"
                    >
                        <template slot="header">
                            <div class="row">
                                <label
                                    class="col-md-6 col-form-label form-control-label"
                                >
                                    <h3
                                        class="mb-0"
                                        v-if="params.id == '' || params.id == 0"
                                    >
                                        {{ $t("order_information") }}
                                    </h3>
                                    <h3 class="mb-0" v-else>
                                        {{ $t("order_information") }} :
                                        {{ this.params.id }}
                                    </h3>

                                    <h3 v-if="params.tracking_number != ''">
                                        Tracking :
                                        {{ this.params.tracking_number }}
                                    </h3>
                                </label>
                            </div>
                        </template>
                        <div>
                            <!-- Selected Product -->
                            <div class="row">
                                <div
                                    class="col-lg-3"
                                    v-for="(o, index) in order_items"
                                    :key="o.id"
                                >
                                    <div class="card">
                                        <img
                                            class="card-img-top"
                                            :src="
                                                GetProductImage(
                                                    o.wms_product_id
                                                )
                                            "
                                            style="max-height:150px; width:150px;margin-left: auto; margin-right: auto;"
                                        />
                                        <div class="card-body">
                                            <h3>
                                                <span>
                                                    {{ o.wms_product_name }}
                                                </span>
                                                (
                                                <span class="text-green">{{ o.pickup_quantity }} </span>
                                                )
                                            </h3>

                                            <!-- Broken -->
											 <hr>
											 <div class="col-12">ชำรุด</div>
                                            <div class="col-md-12">
                                                <base-button
                                                    @click.native="
                                                        handleBrokenAdd(index)
                                                    "
													:disabled="o.good_quantity == 0"
                                                    class="edit"
                                                    type="warning"
                                                    size="sm"
                                                    icon
                                                >
                                                    <i
                                                        class="text-dtac-bt fa fa-plus"
                                                    ></i>
                                                </base-button>

                                                <input
                                                    type="text"
                                                    class="form-control text-center"
                                                    style="display:inline; width:30%; margin-right:10px"
													disabled
                                                    :value="o.broken_quantity"
                                                />

                                                <base-button
                                                    @click.native="
                                                        handleBrokenRemove(
                                                            index
                                                        )
                                                    "
													:disabled="o.broken_quantity == 0"
                                                    class="edit"
                                                    type="warning"
                                                    size="sm"
                                                    icon
                                                >
                                                    <i
                                                        class="text-dtac-bt fa fa-minus"
                                                    ></i>
                                                </base-button>
                                            </div>

                                            <!-- Lost -->
											 <hr>
											 <div class="col-12">สูญหาย</div>
											 
                                            <div class="col-md-12">
                                                <base-button
                                                    @click.native="
                                                        handleLostAdd(index)
                                                    "
													:disabled="o.good_quantity == 0"
                                                    class="edit"
                                                    type="warning"
                                                    size="sm"
                                                    icon
                                                >
                                                    <i
                                                        class="text-dtac-bt fa fa-plus"
                                                    ></i>
                                                </base-button>

                                                <input
                                                    type="text"
                                                    class="form-control text-center"
                                                    style="display:inline; width:30%; margin-right:10px"
													disabled
                                                    :value="o.lost_quantity"
                                                />

                                                <base-button
                                                    @click.native="
                                                        handleLostRemove(index)
                                                    "
													:disabled="o.lost_quantity == 0"
                                                    class="edit"
                                                    type="warning"
                                                    size="sm"
                                                    icon
                                                >
                                                    <i
                                                        class="text-dtac-bt fa fa-minus"
                                                    ></i>
                                                </base-button>
                                            </div>

											<!-- Other -->
											<hr>
											<div class="col-12">อื่น ๆ</div>
											
										   <div class="col-md-12">
											   <base-button
												   @click.native="
													   handleOtherAdd(index)
												   "
												   :disabled="o.good_quantity == 0"
												   class="edit"
												   type="warning"
												   size="sm"
												   icon
											   >
												   <i
													   class="text-dtac-bt fa fa-plus"
												   ></i>
											   </base-button>

											   <input
												   type="text"
												   class="form-control text-center"
												   style="display:inline; width:30%; margin-right:10px"
												   disabled
												   :value="o.other_quantity"
											   />

											   <base-button
												   @click.native="
													   handleOtherRemove(index)
												   "
												   :disabled="o.other_quantity == 0"
												   class="edit"
												   type="warning"
												   size="sm"
												   icon
											   >
												   <i
													   class="text-dtac-bt fa fa-minus"
												   ></i>
											   </base-button>
										   </div>
                                        </div>
                                    </div>
                                </div>
                            </div> <!-- End Product -->


                        </div>
                    </card>
                </div>
            </div>
        </div>

        <!--  Modal -->
        <modal :show.sync="showModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                Loading...
            </form>

            <template slot="footer"> </template>
        </modal>

		<modal
            :show.sync="showSaveModal"
            modal-classes="modal-secondary modal-lg"
        >
		<div class="row">
                <div class="col-md-4">
					สินค้า
                </div>
                <div class="col-md-2 text-center">
					ดี
                </div>
                <div class="col-md-2 text-center">
					ชำรุด
                </div>
                <div class="col-md-2 text-center">
					สูญหาย
                </div>
                <div class="col-md-2 text-center">
					อื่นๆ
                </div>
		</div>
		<hr />
            <div class="row" v-for=" (item,index) in order_items" :key="index">
					<!-- show product good , broken loss -->
                <div class="col-md-4">
					{{  item.wms_product_name }}
                </div>
                <div class="col-md-2 text-center">
					{{  item.good_quantity }}
                </div>
                <div class="col-md-2 text-center">
					{{  item.broken_quantity }}
                </div>
                <div class="col-md-2 text-center">
					{{  item.lost_quantity }}
                </div>
                <div class="col-md-2 text-center">
					{{  item.other_quantity }}
                </div>
            </div>
			<hr/>
			<div class="row">
				<div class="col-md-12">
					<div class="form-group">
						<base-input
							v-model="note"
							placeholder="หมายเหตุ"
							label="หมายเหตุ"
							class="form-control-alternative"></base-input>
					</div>
				</div>
			</div>

			<template slot="footer">
				<button
					type="button"
					class="btn btn-md btn-primary"
					@click="handleSave()"
				>
					{{ $t("save") }}
				</button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showSaveModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
		</modal>

    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import __WEBPACK_EXTERNAL_MODULE__0__ from "vue-flatpickr-component";
import OrderTables from "./OrderTables.vue";

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            StorageTableOrg: "WmsStorage/getData",
            ProductTable: "WmsProduct/getData",
            OrderTable: "Order/getData",
			PlatformTable: "Order/getPlatformTable"
        }),

        StorageTable() {
            return this.StorageTableOrg.filter(item => {
                return item.ID != 1;
            });
        }
    },
    data() {
        return {
            isLoading: false,
            showModal: false,
			showSaveModal: false,
            lock: false,
            barcode: "",
			platform_id:1,
            note: "",
			orders: [],
			order:null,
            order_items: [],
			params : {
				id:0,
				tracking_number:"",
			}
        };
    },
    mounted() {
        this.listProduct();
        this.clearParam();
    },
    methods: {
        ...mapActions({
            createReturn: "Packing/createReturn",
            closeReturn: "Packing/closeReturn",
            listProduct: "WmsProduct/listData",
            listOrder: "Order/listData",
			orderReturn: "Order/setOrderReturn"
        }),

		handleSave(){

			// Reformat
			let params = {
				order_id : this.params.id,
				product_good : [],
				product_broken: [],
				product_lost:[],
				other_reason:[],
				note :this.note 
			} 

			//loop order_items
			for (let i = 0; i < this.order_items.length; i++) {
				let item = this.order_items[i];
				if (item.good_quantity > 0) {
					params.product_good.push({
						wms_product_id: item.wms_product_id,
						wms_product_name: item.wms_product_name,
						barcode: item.barcode,
						pickup_quantity: item.good_quantity,
					});
				}

				if (item.broken_quantity > 0) {
					params.product_broken.push({
						wms_product_id: item.wms_product_id,
						wms_product_name: item.wms_product_name,
						barcode: item.barcode,
						pickup_quantity: item.broken_quantity,
					});
				}

				if (item.lost_quantity > 0) {
					params.product_lost.push({
						wms_product_id: item.wms_product_id,
						wms_product_name: item.wms_product_name,
						barcode: item.barcode,
						pickup_quantity: item.lost_quantity,
					});
				}

				if (item.other_quantity > 0) {
					params.other_reason.push({
						wms_product_id: item.wms_product_id,
						wms_product_name: item.wms_product_name,
						barcode: item.barcode,
						pickup_quantity: item.other_quantity,
					});
				}
			}

			// call api
			this.orderReturn(params).then((res) => {
				console.log("result",res)
				if (res) {
					swal.fire({
						title: this.$t("return_success"),
						text: '',
						icon: "success",
						confirmButtonText: this.$t("ok")
					});
					this.clearParam();
				} else {
					swal.fire({
						title: this.$t("return_fail"),
						text: '',
						icon: "error",
						confirmButtonText: this.$t("ok")
					});
				}
			}).catch((err) => {
				console.log("error",err)
				if (res) {
					swal.fire({
						title: this.$t("return_fail"),
						text: err,
						icon: "error",
						confirmButtonText: this.$t("ok")
					});
				}
			})

		},

		handleLostAdd(index) {
			// check good quantity > 0 , then lost quantity can add good quantity decrease
			if (this.order_items[index].good_quantity > 0) {
				this.order_items[index].good_quantity--;
				this.order_items[index].lost_quantity++;
			}
		},
		handleLostRemove(index) {
			// check lost quantity > 0 , then lost quantity can decrease good quantity increase
			if (this.order_items[index].lost_quantity > 0) {
				this.order_items[index].lost_quantity--;
				this.order_items[index].good_quantity++;
			}
		},

		handleBrokenAdd(index) {
			// check good quantity > 0 , then broken quantity can add good quantity decrease
			if (this.order_items[index].good_quantity > 0) {
				this.order_items[index].good_quantity--;
				this.order_items[index].broken_quantity++;
			}
		},
		handleBrokenRemove(index) {
			if (this.order_items[index].broken_quantity > 0) {
				this.order_items[index].broken_quantity--;
				this.order_items[index].good_quantity++;
			}
		},

		// handleOtherADd
		handleOtherAdd(index) {
			// check good quantity > 0 , then broken quantity can add good quantity decrease
			if (this.order_items[index].good_quantity > 0) {
				this.order_items[index].good_quantity--;
				this.order_items[index].other_quantity++;
			}
		},
		handleOtherRemove(index) {
			if (this.order_items[index].other_quantity > 0) {
				this.order_items[index].other_quantity--;
				this.order_items[index].good_quantity++;
			}
		},

        async handleBarcode() {
            // create variable string of startdate and enddate in format YYYY-MM-DD  , startdate is last 3 days enddate is today
            let startdate = moment()
                .add(-30, "days")
                .format("YYYY-MM-DD");
            let enddate = moment().format("YYYY-MM-DD");

			this.params.tracking_number = ""
			this.params.id  = 0 

            let params = {
                time_from: startdate,
                time_to: enddate,
                tracking_number: this.barcode,
				bo_platform_id: this.platform_id
            };

            await this.listOrder(params);

            let orders = this.OrderTable;

            if (orders.length == 1) {
                // order found
				this.order = orders[0]
				console.log(this.order)
				this.params.id = this.order.ID
				this.params.tracking_number = this.barcode

                let wms_str = this.order.wms_product_summary;
                let wms = JSON.parse(wms_str);

                let items = [];
                for (let i = 0; i < wms.length; i++) {
                    let item = wms[i];
                    items.push({
                        wms_product_id: item.wms_product_id,
                        wms_product_name: item.wms_product_name,
                        barcode: item.barcode,
                        pickup_quantity: item.pickup_quantity,
                        good_quantity: item.pickup_quantity,
                        broken_quantity: 0,
                        lost_quantity: 0,
						other_quantity:0
                    });
                }

                this.order_items = items;
            } else if (orders.length > 1) {
                // show invalid tracking number
                swal.fire({
                    title: this.$t("errors.invalid_tracking_number"),
                    icon: "error",
                    confirmButtonText: this.$t("ok")
                });
            } else {
                // show alert order not found
                swal.fire({
                    title: this.$t("errors.orders.not_found"),
                    icon: "error",
                    confirmButtonText: this.$t("ok")
                });
            }
        },

        clearParam() {
            this.order_items = [];
            this.params.id = "";
            this.params.tracking_number = "";
            this.params.barcode = "";
            this.barcode = "";
			this.note = "";
			this.showSaveModal = false;
            this.state = 0;
        },

        GetProductImage(id) {
            // find product table
            let product = this.ProductTable.find(x => x.ID == id);
            if (product) {
                return (
                    process.env.VUE_APP_API_BASE_URL +
                    "/files/wms/" +
                    product.Image
                );
            } else {
                return "";
            }
        }
    }
};
</script>

<style scoped>
.el-table td {
    padding: 0 !important;
}
</style>
